import React, {useState} from "react";
import CustomDialog from "../../../../core/components/ui/CustomDialog";
import {Box, CircularProgress} from "@mui/material";
import CustomDialogLoaderComponent from "../../../../core/components/common/custom-dialog-loader.component"
import CustomTypography from "../../../../core/components/ui/CustomTypography";
import useGatePassConfiguration from "../../hooks/useGatePassConfiguration";
import GatePassConfigurationStatusDropdownComponent from "../../common/gatepass-configuration-status-dropdown.component";


const UpdateStatusDialog = (props) => {
    const {open, setOpen, selectedProfile} = props;

    const {isUpdatingGatePassConfigurationStatus, updateProfileGatePassConfigurationStatus} = useGatePassConfiguration();

    const [selectedStatus, setSelectedStatus] = useState(selectedProfile?.status);


    const handleStatusChange = (value) => {
        setSelectedStatus(value);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleUpdateStatus = () => {
        const parameters = {
            profile_gatepass_type_uid: selectedProfile?.profile_gatepass_type_uid,       
            status: selectedStatus,
        }

        updateProfileGatePassConfigurationStatus(parameters);
    }

    const actions = [
        {
            label: "Cancel",
            onClick: (e) => setOpen(false),
            variant: "outlined",
            customStyles: {
                opacity: 1, mr: 1
            }
        },
        {
            label: "Update",
            onClick: (e) => (selectedStatus && !isUpdatingGatePassConfigurationStatus) ? handleUpdateStatus(e) : null,
            customStyles: {
                opacity: (selectedStatus && !isUpdatingGatePassConfigurationStatus) ? "100%" : "55%",
                cursor: (selectedStatus && !isUpdatingGatePassConfigurationStatus) ? "pointer" : "not-allowed !important",
                visibility: (isUpdatingGatePassConfigurationStatus) ? "hidden" : "visible",
            },
        }
    ]

    const globalSx = {
       //
    }


    return (
        <>
            <CustomDialog
                open={open}
                onClose={(isUpdatingGatePassConfigurationStatus) ? null : handleClose}
                title="Update Status"
                subtitle={"Manage profile gate pass configuration status in real-time"}
                hasDividers={true}
                content={
                    <Box>
                        {(isUpdatingGatePassConfigurationStatus) ?
                            <Box sx={{mb: "80px"}}>
                                <CustomDialogLoaderComponent 
                                    icon={<CircularProgress size={40} sx={{color: "#2196f3"}} />} 
                                    message={"Updating profile gate pass configuration status..."}
                                />
                            </Box>
                        : 
                            <>
                                <CustomTypography 
                                    variant="subtitle2"
                                    text={"Status"}
                                    customStyles={{
                                        mb: (selectedStatus) ? 2 : 1
                                    }}
                                />

                                <GatePassConfigurationStatusDropdownComponent 
                                    value={selectedStatus}
                                    onChange={handleStatusChange}
                                    fullWidth={true}
                                    size={"medium"}
                                /> <br/>
                            </>
                        }
                    </Box>
                }
                actions={!isUpdatingGatePassConfigurationStatus && actions}
                maxWidth={"sm"}
                customStyles={{}}
                globalSx={globalSx}
            />
        </>
    )
}

export default UpdateStatusDialog
